module.exports = __webpack_public_path__ + "static/img/8.a7e5704.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-h5/8.jpg
// module id = 6CQr
// module chunks = 2